import axios from 'axios';
import * as Sentry from "@sentry/vue";

export function getUserNotifications() {
  return axios
    .get('/api/?entity=user&action=getNotifications')
    .then(response => {
      const notifications = response.data && response.data.data;
      if (Array.isArray(notifications)) {
        return notifications;
      }

        Sentry.captureException(new Error(`Failed to load notifications`), { level: 'info' });
      return [];
    });
}
